module.exports = __webpack_public_path__ + "img/card.64f343c7.svg";